import { useAuthStore } from './auth';

/**
 * 登录会话身份（R07）：登录用户名加本次登录的会话编号，未登录为 null。
 *
 * <ul>
 *   <li>为什么不能只看用户名：同一账号登出后再登录、或 A→B→A，用户名一样，但已经是另一次登录；上一次登录发出的请求、
 *       刷新与弹窗都不能借用新登录的令牌或把结果写进新登录的页面。</li>
 *   <li>刷新令牌不是新的登录：登录状态的 refreshSession 只换令牌，沿用会话编号，同一会话里等待中的请求照常重放。</li>
 *   <li>谁用：共用请求客户端（发送、刷新与重放的边界），计划与取消两类弹窗（会话关闭、回包能否展示、最后确认能否发送）。
 *       各页面不另写身份工具。待确认原请求也只属于本次登录；退出或新登录清空，不用新登录身份重放旧请求。</li>
 *   <li>会话编号只在本页面区分“是不是同一次登录”，不发给服务端，也不是凭据。</li>
 * </ul>
 */
interface LoginSessionFields {
  user?: { username: string } | null;
  loginSessionId?: string | null;
}

/** 从登录状态取登录会话身份。 */
export function loginSessionOf(state: LoginSessionFields): string | null {
  const username = state.user?.username;
  return username ? `${username}#${state.loginSessionId ?? ''}` : null;
}

/** 当前登录会话身份；未登录为 null。 */
export function currentLoginSession(): string | null {
  return loginSessionOf(useAuthStore.getState());
}

/** 当前登录会话身份（随登录状态变化重新渲染）。 */
export function useLoginSession(): string | null {
  return useAuthStore(loginSessionOf);
}
